const loadSocialShare = () => {
  const shareLinks = document.getElementsByClassName('social-share-button');

  for (let shareLink of shareLinks) {
    shareLink.addEventListener('click', () => {
      let width = 700;
      let height = 500;
      let left = screen.width / 2 - width / 2;
      let top = screen.height / 2 - height / 2;

      window.open(
        shareLink.getAttribute('data-link'),
        'sloan-social-share',
        'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
        width +
        ', height=' +
        height +
        ', top=' +
        top +
        ', left=' +
        left
      );
    });
  }
};

export default loadSocialShare;
